import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../../core/shared/classes/api';
import { ApiService } from '../../core/services/api.service';

import { ModuleMapping } from '../classes/moduleMapping';

@Injectable()
export class Z16ProModuleMappingService {

    constructor (
        private apiService: ApiService
    ) { }

    fetchByModuleName(module: string): Observable<ApiResponse> {
        return this.apiService.get(`z16pro/modules-mappings/module/${module}`);
    }

    save(modulesMappings: Array<ModuleMapping>): Observable<ApiResponse> {
        const data = modulesMappings.map(mapping => mapping.toJson());

        return this.apiService.post(`z16pro/modules-mappings`, data);
    }


}
